import { RootState } from '../../../../rootReducer';

export const seriesReportSelector = (state: RootState) => state.eventsLogModuleReducer.SeriesReportReducer;
